



















































/* eslint-disable */
import { mapState } from 'vuex';
import { Route } from 'vue-router'
import { Dialog } from '@zyf2e/capui-mobile';
import Component from 'vue-class-component';
import { Ref, Watch } from 'vue-property-decorator';

import { SPECIALIST, DEPARTMENT_SEARCH } from '@/constant';
import { IspecialistDetail, IgetDoctorSearchParam } from '@/store/specialist/index.d';
import { SearchBar, SearchPlaceholder, SearchPanel } from '@/components/SearchBox';
import {
  commitSetSearchText,
  commitSetSearchHistory,
  dispatchSearchSpecialist,
  commitClearSearchHistory,
  dispatchDepartmentDoctorSearch
} from '@/store/specialist';
import Webview from '@/webview';
import SearchFilter from '@/pages/DoctorSearch/SearchFilter.vue';
import {
  FILTER_TYPE_ENUM,
  IfilterVaule,
  ItreeSelectItemChild,
  IdropdownValues
} from '@/pages/DoctorSearch/SearchFilter';

Component.registerHooks(['beforeRouteEnter']);

@Component({
  name: 'DoctorSearch',
  components: {
    SearchBar,
    SearchPanel,
    SearchPlaceholder,
    SearchFilter
  },
  computed: {
    ...mapState(SPECIALIST, ['searchText', 'searchHistory'])
  }
})
export default class DoctorSearch extends Webview {
  activitySearch = false;

  searchText!: string;

  searchHistory!: string[];

  // activated() {
  //   if (this.defaultDepartmentId !== this.$route.params.id) {
  //     this.initSearchMode();
  //     this.clearSearchAndSearch();
  //     this.$router.replace(this.$route)
  //   }
  // }

  get telescopeMap() {
    return this.$route.meta.telescopeMap
  }

  toggleSearch() {
    this.activitySearch = !this.activitySearch;
  }

  async clearSearchHistory() {
    try {
      await Dialog.confirm({
        title: '确定删除历史记录',
        message: '删除后记录将全部清除，确定删除吗？'
      });
      commitClearSearchHistory(this.$store);
    } catch (err) {
      // do nothing
    }
  }

  submitSearch(searchText: string) {
    if (!searchText) {
      return;
    }
    commitSetSearchText(this.$store, searchText);
    commitSetSearchHistory(this.$store, searchText);
    this.toggleSearch();
    this.clearSearchAndSearch();
    // this.filterRef.clear();
    // this.search();
  }

  conditions: IfilterVaule = {};

  specialists: IspecialistDetail[] = [];
  isLoading = false;

  isFinish = false;

  pageNo = 0;

  pageSize = 20;
  specialistsFlag = false;

  FILTER_TYPE_ENUM = FILTER_TYPE_ENUM;

  defaultDepartmentId = '';

  @Ref('filter')
  readonly filterRef!: SearchFilter;

  get isDepartmentSearch() {
    return this.$route.name === DEPARTMENT_SEARCH;
  }

  get noSpeicalist() {
    return this.specialists.length <= 0 && this.isFinish;
  }

  created() {
    this.initSearchMode();
    // this.search();
    this.registFunc({
      type: 'search',
      func: this.search
    });
  }

  initSearchMode() {
    const { isDepartmentSearch } = this;
    if (isDepartmentSearch) {
      this.defaultDepartmentId = this.$route.params.id;
      if (!this.defaultDepartmentId) {
        this.openDepartmentList();
      }
    }
    if (!isDepartmentSearch) {
      this.clearSearchAndSearch();
    }
  }

  menuItemClick(id: number) {
    const { isDepartmentSearch } = this;
    const nextRoute = `${this.constant.DEPARTMENT_SEARCH}/${id}`;
    if (isDepartmentSearch && nextRoute !== this.$route.fullPath) {
      this.$router.replace(nextRoute);
    }

    this.specialistsFlag = !this.specialistsFlag;
  }

  @Watch('conditions', { deep: true, immediate: false })
  watchConditions() {
    this.clearSearchAndSearch();
  }
  clearSearchAndSearch() {
    this.clearSearchResult();
    this.search();
  }
  clearSearchResult() {
    this.specialists.length = 0;
    this.isFinish = false;
    this.isLoading = false;
    this.pageNo = 0;
  }

  async search() {
    this.isLoading = true;
    const { parentId, id, level } = (this.conditions[FILTER_TYPE_ENUM.CITY] || {}) as ItreeSelectItemChild;
    const { id: departmentId = this.defaultDepartmentId, level: departmentType = 2 } = (this.conditions[
      FILTER_TYPE_ENUM.DEPARTMENT
    ] || {}) as ItreeSelectItemChild;
    this.menuItemClick(departmentId as number);
    const condition = (this.conditions[FILTER_TYPE_ENUM.CONDITION] || {}) as IdropdownValues;

    this.pageNo += 1;

    const params: IgetDoctorSearchParam = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      regionId: (parentId || id) as string,
      regionType: level,
      departmentId: departmentId ? departmentId.toString() : undefined,
      departmentType,
      areaName: this.location,
      condition: Array.prototype.concat(...Object.entries(condition).map(entry => entry[1]))
    };
    if (!departmentId) {
      delete params.departmentType;
    }
    let dispatch = dispatchDepartmentDoctorSearch;

    if (!this.isDepartmentSearch) {
      params.keyword = this.searchText;
      dispatch = dispatchSearchSpecialist;
    }

    const { count = 0, data } = await dispatch(this.$store, {
      ...params,
      keyword: this.searchText
    });

    this.specialists.push(...data);
    this.isLoading = false;
    this.isFinish = this.specialists.length >= count;
  }

  openDepartmentList() {
    this.$nextTick(() => this.filterRef.openTree(FILTER_TYPE_ENUM.DEPARTMENT));
  }
}
